import * as tslib_1 from "tslib";
import { UiModalComponent } from '@components';
import { ProcessService } from '@services';
import { BehaviorSubject } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { ProcessSettingsComponent } from '../../shared';
var ProccessSettingsModalComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ProccessSettingsModalComponent, _super);
    function ProccessSettingsModalComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading$ = new BehaviorSubject(false);
        _this._processService = _this._injector.get(ProcessService);
        return _this;
    }
    ProccessSettingsModalComponent.prototype.onSubmit = function () {
        var _this = this;
        if (this.processSetting.form.invalid) {
            return;
        }
        this.loading$.next(true);
        this._processService
            .patch(this.context.data.id, {
            processSettings: this.processSetting.form.value,
        })
            .pipe(finalize(function () { return _this.loading$.next(false); }))
            .subscribe(function () {
            _this.closeModal();
        });
    };
    return ProccessSettingsModalComponent;
}(UiModalComponent));
export { ProccessSettingsModalComponent };
